// Module
var code = "<administration-accounts-rooms-grid title=\"$ctrl.title\" on-select=\"$ctrl.selectRoom($event)\"></administration-accounts-rooms-grid>\n\n<tabs-navigation identifier=\"app.administration.accounts.rooms\"\n                 state=\"app.administration.accounts.rooms.list\"\n                 on-exec=\"$ctrl.addRoom()\">\n</tabs-navigation>\n";
// Exports
module.exports = code;